/* eslint-disable */
export default {
  loginButton: '登入',
  signupButton: '您是新使用者嗎？註冊',
  version: '版本',
} as const;

// @key: @#@"loginButton"@#@ @source: @#@"Sign In"@#@
// @key: @#@"signupButton"@#@ @source: @#@"New user? Sign Up"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
